module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-e65cf5ab.svg";